module.exports = __webpack_public_path__ + "static/media/Scarcity Effect - will-myers-ku_ttDpqIVc-unsplash.5c5b9b5f.jpg";